import React, { useContext } from 'react'
import { DataContext } from './DataContext'
import AnalyteResetSelector from '../../../elem/chart/AnalyteResetSelector'

const ResetDropdown = () => {
    const { resetZoom, resetAnalytes, resetExpanded, toggleResetExpanded } = useContext(DataContext)

    const onResetAnalytes = () => {
        resetAnalytes()
        toggleResetExpanded(false)
    }

    const onResetZoom = () => {
        resetZoom()
        toggleResetExpanded(false)
    }

    return (
        <AnalyteResetSelector
            resetExpanded={resetExpanded}
            resetAnalytesFunction={onResetAnalytes}
            resetZoomFunction={onResetZoom}
        />
    )
}

export default ResetDropdown